import React, { createContext, useContext, useEffect } from 'react'
import type { MainWindowPlatform, MainWindowPlatformContext } from './types'

const MainWindowPlatformContext = createContext<MainWindowPlatformContext | null>(null)

interface MainWindowPlatformProviderProps {
	platform: MainWindowPlatform;
	children: React.ReactNode;
}

export const MainWindowPlatformProvider: React.FC<MainWindowPlatformProviderProps> = ({ platform, children }) => {
	useEffect(() => {
		// Cleanup on unmount
		return () => {
			platform.cleanup()
		}
	}, [platform])

	return (
		<MainWindowPlatformContext.Provider value={{ platform }}>
			{children}
		</MainWindowPlatformContext.Provider>
	)
}

export const useMainWindowPlatform = (): MainWindowPlatform => {
	const context = useContext(MainWindowPlatformContext)
	if (!context) {
		throw new Error('useMainWindowPlatform must be used within a MainWindowPlatformProvider')
	}
	return context.platform
}
